import { FC } from 'react';
import classNames from 'classnames';
import { DoubleRightOutlined } from '@ant-design/icons';

import { Language } from 'enums';

import styles from './NavigationFooter.module.scss';

export type NavigationFooterProps = {
  version?: string;
  language?: Language;
  languages?: Language[];
  onLanguageChange?: (language: Language) => void;
  collapsed?: boolean;
  onToggleCollapse?: () => void;
  collapseLabel?: string;
};

export const NavigationFooter: FC<NavigationFooterProps> = ({
  version = '',
  language: selectedLanguage,
  languages = [],
  onLanguageChange,
  collapsed = false,
  onToggleCollapse,
  collapseLabel,
}) => {
  const selectLanguage = (language: Language) => {
    onLanguageChange?.(language);
  };

  return (
    <div className={classNames(styles.navigationFooter, { [styles.collapsed]: collapsed })}>
      <div className={styles.languages}>
        {languages.map((language) => {
          return (
            <span
              key={language}
              className={classNames(styles.language, {
                [styles.languageActive]: language === selectedLanguage,
              })}
              onClick={() => selectLanguage(language)}
            >
              {language.toUpperCase()}
            </span>
          );
        })}
      </div>

      {(!collapsed && version) || onToggleCollapse ? (
        <div className={styles.footerBottom}>
          {!collapsed && <span className={styles.version}>v{version}</span>}
          {onToggleCollapse && (
            <button
              type="button"
              aria-label={collapseLabel}
              className={styles.collapseButton}
              onClick={onToggleCollapse}
            >
              <DoubleRightOutlined className={classNames(styles.collapseIcon, { [styles.expanded]: !collapsed })} />
            </button>
          )}
        </div>
      ) : null}
    </div>
  );
};
